import React from 'react';
import { ProductList } from '../components/Products/ProductList';

export const Products = () => {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Products</h1>
      <ProductList />
    </div>
  );
};